import React from 'react';
import {withDynamicComponents} from 'higher-order-components';
import GlobalNavigation from '../../containers/global-navigation';
import PromoNavigation from '../../blocks/promo-navigation';
// import CarNavigation from '../../containers/html';
import Html from '../../containers/html';
import CarNavigation from '../../blocks/car-navigation';
import GlobalNavigationLink from '../../containers/global-navigation/link';

const GlobalNavigationBlock = props => <GlobalNavigation {...props} />;
GlobalNavigationBlock.displayName = 'GlobalNavigation';

export default withDynamicComponents({
  componentWhitelist: [
    PromoNavigation,
    CarNavigation,
    GlobalNavigationLink,
    Html
  ],
  mapInputToOutput: [
    ['components', 'children'],
  ],
})(GlobalNavigationBlock);



// WEBPACK FOOTER //
// ./src/blocks/global-navigation/index.jsx